// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("@rails/activestorage").start()
require("channels")
require("jquery")
require("@nathanvda/cocoon")
// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import './bootstrap_custom.js'
// import '../stylesheets/tailwindcss.scss'
import '../stylesheets/application.scss'
import './instant_submit_select.js'
import './file_input.js'
import './image_input_preview.js'
import '../admin/copy_buttons'
import "@fortawesome/fontawesome-free/css/all.css"
import './product_form.js'
import './mission.js'
import 'bootstrap-datepicker/dist/js/bootstrap-datepicker.js'
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.standalone.css'
// Support component names relative to this directory:
var componentRequireContext = require.context("components", true);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);

// Only the admin user profile uses Turbo (its tab frame); keep it off every other page.
if (document.getElementById('user_tab')) import('../admin/user_tabs')
